var _desc, _defs, _rect, _rect2, _rect3, _circle, _circle2, _g, _image, _g2, _path, _path2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreIntelligenceDashboardDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 900 650",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "FleetCore fleet intelligence dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A commercial vehicle connected to verified driver, odometer and refuelling evidence, with 98 percent of fuel accounted for and no anomaly detected.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0B172C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030A18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "row",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0D1B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#21C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gaugeGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 28,
    height: 28,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.1,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blueGlow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 864,
    height: 614,
    rx: 25,
    fill: "url(#panel)",
    stroke: "#6C7C96",
    strokeOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 832,
    height: 582,
    rx: 19,
    fill: "none",
    stroke: "#91A0B8",
    strokeOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 62,
    width: 500,
    height: 450,
    rx: 18,
    fill: "url(#grid)",
    opacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 285,
    r: 266,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 285,
    r: 220,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0B8CFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    filter: "url(#blueGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 154v-28h32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 154v-28h-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 446v28h32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 446v28h-32"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 48,
    y: 111,
    width: 510,
    height: 340,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "fleetcore-commercial-van.png",
    href: "fleetcore-commercial-van.png"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#087CFF",
    filter: "url(#blueGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 433,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 348,
    r: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308 433 420 492h138",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5,
    strokeOpacity: 0.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504 348h70",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5,
    strokeOpacity: 0.88
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(704 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 126,
    fill: "url(#gaugeGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 96,
    fill: "#040B18",
    stroke: "#203754",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 89,
    fill: "none",
    stroke: "#122944",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    r: 89,
    fill: "none",
    stroke: "url(#ring)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeDasharray: "510 50",
    transform: "rotate(-86)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 108,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.38,
    strokeDasharray: "2 7"
  }), /*#__PURE__*/React.createElement("text", {
    y: -2,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 760,
    textAnchor: "middle"
  }, "98%"), /*#__PURE__*/React.createElement("text", {
    y: 31,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    textAnchor: "middle"
  }, "Fuel accounted for"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 304)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 60,
    rx: 12,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30,
    r: 20,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 23,
    r: 6,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 42c1.5-8 6.5-11 11-11s9.5 3 11 11",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 36,
    fill: "#FFFFFF",
    fontSize: 17
  }, "Driver verified"), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 30,
    r: 16,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252 30 6 6 11-13",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 60,
    rx: 12,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30,
    r: 20,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34a14 14 0 1 1 26 0",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 31 8-7M21 26l3 2M40 26l-3 2M31 18v4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 2.5,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 36,
    fill: "#FFFFFF",
    fontSize: 17
  }, "51 284 km"), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 30,
    r: 16,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252 30 6 6 11-13",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 444)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 60,
    rx: 12,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30,
    r: 20,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17h13v26H23zM26 21h7v8h-7zM36 23h4l5 5v10c0 4-5 4-5 0v-7h-4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 36,
    fill: "#FFFFFF",
    fontSize: 17
  }, "63.2 L refuelled"), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 30,
    r: 16,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252 30 6 6 11-13",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 538)",
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 810,
    height: 58,
    rx: 13,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 29,
    r: 21,
    fill: "#081A32",
    stroke: "#087CFF",
    filter: "url(#blueGlow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15 44 20v9c0 8-5 14-11 18-6-4-11-10-11-18v-9l11-5Z",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 29 5 5 8-10",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 36,
    fill: "#FFFFFF",
    fontSize: 19
  }, "No fuel anomaly detected"), /*#__PURE__*/React.createElement("path", {
    d: "M355 29h385",
    stroke: "#087CFF",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 744,
    cy: 29,
    r: 3.5,
    fill: "#087CFF",
    filter: "url(#blueGlow)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreIntelligenceDashboardDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-intelligence-dashboard-desktop.3ab107697e9350ef70acd622309cd34d.svg";
export { ForwardRef as ReactComponent };